import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Button,
    TextField,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
    Autocomplete,
} from "@mui/material";
import { ModalTemplate } from "../shared/ModalForms";
import { useUser } from "../../Context/UserContext";
import { AddressFormChirpStack } from "../Forms/AddressForm";
import { getAddressByGroupId } from "../../Api/AddressApi";
import { addDeviceLora } from "../../Api/DevicesApi";
import { typeChanel, typeDevice, typeIoT, typeResourse, typeOwner } from "../../constants/constants";
import { GroupForm } from "Components/Forms/NbiotForm";


const getSteps = (props) => {

    const {
        formData,
        setFormData,
        handleAddressSuccess,
        handleOpenAddress,
        handleOpenGroup,
        handleGroupSuccess,
        handleChange,
        handleCloseGroup,
        handleCloseAddress,
        openAddress,
        openGroup,
        user,
        filteredAddressList, } = props;


    const baseSteps = [
        <>
            <DialogContentText>Основные данные</DialogContentText>
            <FormControl required fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Количество каналов устройства</InputLabel>
                <Select
                    value={formData.typeCh}
                    onChange={handleChange("typeCh")}
                    label="Количество каналов устройства"
                >
                    {typeChanel.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl required fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств</InputLabel>
                <Select
                    label="Группа устройств"
                    value={formData.group}
                    onChange={handleChange("group")}
                >
                    <MenuItem value="new" onClick={handleOpenGroup}>
                        + Создать новую группу
                    </MenuItem>
                    {user.group.map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </Select>
                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>
            {(formData.group) ? (
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                    <Autocomplete
                        value={(Array.isArray(filteredAddressList) &&
                            filteredAddressList.find(addr => String(addr._id) === String(formData.address)))}
                        onChange={(event, newValue) => {
                            if (newValue && newValue._id === 'new') {
                                handleOpenAddress();
                            } else if (newValue) {
                                console.log("Сохраняем id:", newValue._id);
                                setFormData(prev => ({ ...prev, address: newValue._id }));
                            } else {
                                console.log("Очищаем адрес");
                                setFormData(prev => ({ ...prev, address: "" }));
                            }
                        }}
                        freeSolo
                        options={[{ _id: 'new', label: '+ Добавить адрес' }, ...(filteredAddressList || [])]}
                        getOptionLabel={(option) =>
                            option._id === 'new' ? '' :
                                option.label || `${option.country || ''}, ${option.region || ''}, ${option.city || ''}, ${option.street || ''}, ${option.building || ''}`
                        }
                        renderInput={(params) => <TextField required {...params} label="Адрес" />}
                        renderOption={(props, option) => (
                            <li {...props} key={option._id}>
                                {option.label
                                    ? option.label
                                    : `${option.country || ''}, ${option.region || ''}, ${option.city || ''}, ${option.street || ''}, ${option.building || ''}`}
                            </li>
                        )}
                    />

                    <ModalTemplate
                        open={openAddress}
                        onClose={handleCloseAddress}
                    >
                        <AddressFormChirpStack onSuccess={handleAddressSuccess} />

                    </ModalTemplate>
                </FormControl>
            ) : (<></>)}


            <TextField fullWidth sx={{ marginTop: 2 }} label="Квартира/помещение" value={formData.address_number} onChange={handleChange("address_number")} />
        </>,
        <>
            <DialogContentText>Данные IoT-устройства</DialogContentText>
            <FormControl required fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Тип устройства</InputLabel>
                <Select
                    value={formData.dev_type_iot}
                    onChange={handleChange("dev_type_iot")}
                    label="Тип устройства"
                >
                    {typeIoT.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField fullWidth required sx={{ marginTop: 2 }} label="DevEUI" value={formData.module_number} onChange={handleChange("module_number")} />
            <TextField fullWidth required sx={{ marginTop: 2 }} label="AppKey" value={formData.token} onChange={handleChange("token")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Производитель" value={formData.manufacture} onChange={handleChange("manufacture")} />
        </>,
        <>
            <DialogContentText>Платежные данные</DialogContentText>
            <FormControl required fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Тип владельца</InputLabel>
                <Select
                    value={formData.type_ownership}
                    onChange={handleChange("type_ownership")}
                    label="Тип владельца"
                >
                    {typeOwner.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField fullWidth sx={{ marginTop: 2 }} label="Владелец" value={formData.ownership} onChange={handleChange("ownership")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Код прибора в ЕРИП" value={formData.devicecode} onChange={handleChange("devicecode")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Реестр" value={formData.registry} onChange={handleChange("registry")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Лицевой счет" value={formData.accountnumber} onChange={handleChange("accountnumber")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Абонентский район" value={formData.subscriptionarea} onChange={handleChange("subscriptionarea")} />
        </>,

    ];

    const channelSteps = [
        <>
            <DialogContentText>Данные устройства (Канал 1)</DialogContentText>
            <FormControl required fullWidth sx={{ mt: 2 }}>
                <InputLabel>Тип устройства</InputLabel>
                <Select
                    label="Тип устройства"
                    value={formData.dev_type}
                    onChange={handleChange("dev_type")}
                >
                    {typeDevice.map(({ key, label }) => (
                        <MenuItem key={key} value={key}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField required fullWidth sx={{ marginTop: 2 }} label="Заводской номер" value={formData.dev_number} onChange={handleChange("dev_number")} />
            <FormControl required fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Тип ресурса</InputLabel>
                <Select
                    value={formData.resourse_type}
                    onChange={handleChange("resourse_type")}
                    label="Тип ресурса"
                >
                    {typeResourse.map((type) => (
                        <MenuItem key={type} value={type}>
                            {type}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField fullWidth required sx={{ marginTop: 2 }} label="Множитель" value={formData.factor} onChange={handleChange("factor")} />
            <TextField fullWidth required sx={{ marginTop: 2 }} label="Начальные показания" value={formData.start_volume} onChange={handleChange("start_volume")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Марка прибора" value={formData.brand} onChange={handleChange("brand")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Диаметр" value={formData.diameter_body} onChange={handleChange("diameter_body")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Комментарий" value={formData.commit} onChange={handleChange("commit")} />
            <TextField fullWidth sx={{ marginTop: 2 }} label="Дата окончания поверки" value={formData.verification_end_date} onChange={handleChange("verification_end_date")} />
        </>,
    ];

    if (formData.typeCh === "Двухканальный") {
        channelSteps.push(
            <>
                <DialogContentText>Данные устройства (Канал 2)</DialogContentText>
                <FormControl required fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Тип устройства</InputLabel>
                    <Select
                        label="Тип устройства"
                        value={formData.dev_type2}
                        onChange={handleChange("dev_type2")}
                    >
                        {typeDevice.map(({ key, label }) => (
                            <MenuItem key={key} value={key}>
                                {label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField required fullWidth sx={{ marginTop: 2 }} label="Заводской номер" value={formData.dev_number2} onChange={handleChange("dev_number2")} />
                <FormControl required fullWidth sx={{ marginTop: 2 }}>
                    <InputLabel>Тип ресурса</InputLabel>
                    <Select
                        value={formData.resourse_type2}
                        onChange={handleChange("resourse_type2")}
                        label="Тип ресурса"
                    >
                        {typeResourse.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField fullWidth required sx={{ marginTop: 2 }} label="Множитель" value={formData.factor2} onChange={handleChange("factor2")} />
                <TextField fullWidth required sx={{ marginTop: 2 }} label="Начальные показания" value={formData.start_volume2} onChange={handleChange("start_volume2")} />
                <TextField fullWidth sx={{ marginTop: 2 }} label="Марка прибора" value={formData.brand2} onChange={handleChange("brand2")} />
                <TextField fullWidth sx={{ marginTop: 2 }} label="Диаметр" value={formData.diameter_body2} onChange={handleChange("diameter_body2")} />
                <TextField fullWidth sx={{ marginTop: 2 }} label="Комментарий" value={formData.commit2} onChange={handleChange("commit2")} />
                <TextField fullWidth sx={{ marginTop: 2 }} label="Дата окончания поверки" value={formData.verification_end_date2} onChange={handleChange("verification_end_date2")} />
            </>,
        );
    }

    return [...baseSteps, ...channelSteps];
};

export default function AddDeviceDialogLora({ showTosModal, handleClose }) {
    const [step, setStep] = useState(0);
    const [addressList, setAddressList] = useState([]);
    const [filteredAddressList, setFilteredAddressList] = useState(addressList);
    const [addNew, setAddNew] = useState(false);
    const { user } = useUser();


    const [formData, setFormData] = useState({
        group: "",
        typeCh: "",
        address: "",
        address_number: "",
        dev_type_iot: "",
        brand_iot: "LoRa",
        module_number: "",
        token: "",
        manufacture: "",
        dev_type: "",
        dev_number: "",
        resourse_type: "",
        brand: "",
        diameter_body: "",
        commit: "",
        verification_end_date: "",
        factor: "",
        start_volume: 0.0,
        dev_type2: "",
        dev_number2: "",
        resourse_type2: "",
        brand2: "",
        diameter_body2: "",
        commit2: "",
        verification_end_date2: "",
        factor2: "",
        start_volume2: 0.0,
        registry: "",
        ownership: "",
        type_ownership: "",
        devicecode: "",
        accountnumber: "",
        subscriptionarea: "",
    });

    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);

    const handleGroupSuccess = (group) => {
        handleChange('group');
        handleCloseGroup();
    };

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const handleNext = () => setStep((prev) => prev + 1);
    const handleBack = () => setStep((prev) => prev - 1);
    const handleCancel = () => {
        setStep(0);
        setFormData({
            group: "",
            typeCh: "",
            address: "",
            address_number: "",
            dev_type_iot: "",
            brand_iot: "LoRa",
            module_number: "",
            token: "",
            manufacture: "",
            dev_type: "",
            dev_number: "",
            resourse_type: "",
            brand: "",
            diameter_body: "",
            commit: "",
            verification_end_date: "",
            factor: "",
            start_volume: 0.0,
            dev_type2: "",
            dev_number2: "",
            resourse_type2: "",
            brand2: "",
            diameter_body2: "",
            commit2: "",
            verification_end_date2: "",
            factor2: "",
            start_volume2: 0.0,
            registry: "",
            ownership: "",
            type_ownership: "",
            devicecode: "",
            accountnumber: "",
            subscriptionarea: "",
        });
        handleClose();
    };

    const handleAddDevice = async () => {
        try {
            const res = await addDeviceLora(formData)
            if (res.status === 200) {
                console.log("Устройство успешно добавлено:", res.data);
                handleCancel();
            }
            else {
                console.error("Ошибка при добавлении устройства:", res);
            }

        } catch (error) {
            console.error("Ошибка при сохранении устройства:", error);
        }

    }

    const handleAddressSuccess = (newAddress) => {
        setAddNew(true);
        handleChange('address');
        handleCloseAddress();
    };

    useEffect(() => {
        async function fetchAddress() {
            try {
                if (formData.group) {
                    const data = await getAddressByGroupId(formData.group);
                    setAddressList(data);
                    return;
                }

            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }
        }

        fetchAddress();

    }, [formData.group, addNew]);

    useEffect(() => {
        if (formData.group) {
            const filteredAddresses = addressList.filter(
                addr => addr.group === formData.group
            );
            setFilteredAddressList(filteredAddresses);
        } else {
            setFilteredAddressList(addressList);
        }
    }, [formData.group, addressList]);

    const props = {
        formData,
        setFormData,
        handleAddressSuccess,
        handleOpenAddress,
        handleOpenGroup,
        handleGroupSuccess,
        handleChange,
        handleCloseGroup,
        handleCloseAddress,
        openAddress,
        openGroup,
        user,
        filteredAddressList,
    }

    const steps = getSteps(props);



    return (
        <Dialog
            open={showTosModal}
            onClose={(event, reason) => {
                if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
                    return;
                }
                handleClose();
            }}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle textAlign="center">Добавление устройства</DialogTitle>

            <DialogContent>{steps[step]}</DialogContent>

            <DialogActions>
                <Button onClick={handleCancel}>Отмена</Button>
                {step > 0 && <Button onClick={handleBack}>Назад</Button>}
                {step < steps.length - 1 ? (
                    <Button onClick={handleNext}>Далее</Button>
                ) : (
                    <Button onClick={() => {
                        handleAddDevice();
                    }}>
                        Готово
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
